import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const SnackBarStyle = styled.div`
  ${fontFamily.sourceSansPro.regular};
  animation: slide 4000ms;
  color: ${colors.softRed};
  padding: 28px 20px 28px 68px;
  position: relative;

  &.success-type {
    background-color: ${colors.limeGreen};
    color: ${colors.white};

    .snack-bar-icon {
      svg {
        fill: ${colors.white};
      }
    }
  }

  &.error-type {
    background-color: ${colors.softRed};
    color: ${colors.white};

    .snack-bar-icon {
      svg {
        fill: ${colors.white};
      }
    }
  }

  .snack-bar-icon {
    height: 24px;
    left: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;

    svg {
      display: block;
      height: auto;
      width: 100%;
    }
  }

  @keyframes slide {
    0% {
      transform: translateY(-125%);
    }

    25%,
    75% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-125%);
    }
  }
`;
